import React, { useContext } from "react";

interface ContextValue {
  saml_sso_enabled: boolean;
  azure_sso_enabled: boolean;
  sso_only: boolean;
}

const defaultState: ContextValue = {
  saml_sso_enabled: false,
  azure_sso_enabled: false,
  sso_only: false
};

export const SSOContext = React.createContext<ContextValue>(defaultState);
export const useSSOContext = (): ContextValue => useContext<ContextValue>(SSOContext);
